import styled from 'styled-components';
import { Button } from 'antd';

export const PrimaryButton = styled(Button)`
  background-color: #703895;
`;
